"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductVariantsInnerRgbToJSON = exports.ProductVariantsInnerRgbFromJSONTyped = exports.ProductVariantsInnerRgbFromJSON = exports.instanceOfProductVariantsInnerRgb = exports.ProductVariantsInnerRgbViewsEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.ProductVariantsInnerRgbViewsEnum = {
    Front: 'front',
    Back: 'back'
};
/**
 * Check if a given object implements the ProductVariantsInnerRgb interface.
 */
function instanceOfProductVariantsInnerRgb(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductVariantsInnerRgb = instanceOfProductVariantsInnerRgb;
function ProductVariantsInnerRgbFromJSON(json) {
    return ProductVariantsInnerRgbFromJSONTyped(json, false);
}
exports.ProductVariantsInnerRgbFromJSON = ProductVariantsInnerRgbFromJSON;
function ProductVariantsInnerRgbFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'r': !(0, runtime_1.exists)(json, 'r') ? undefined : json['r'],
        'g': !(0, runtime_1.exists)(json, 'g') ? undefined : json['g'],
        'b': !(0, runtime_1.exists)(json, 'b') ? undefined : json['b'],
        'views': !(0, runtime_1.exists)(json, 'views') ? undefined : json['views'],
    };
}
exports.ProductVariantsInnerRgbFromJSONTyped = ProductVariantsInnerRgbFromJSONTyped;
function ProductVariantsInnerRgbToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'r': value.r,
        'g': value.g,
        'b': value.b,
        'views': value.views,
    };
}
exports.ProductVariantsInnerRgbToJSON = ProductVariantsInnerRgbToJSON;
